"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBlock = exports.createField = exports.createJmrHeader = exports.jmrBuilder = void 0;
const slateTypes_1 = require("./types/slateTypes");
const agendaUtil_1 = require("./util/agendaUtil");
const actionUtil_1 = require("./util/actionUtil");
const metaUtil_1 = require("./util/metaUtil");
const _1 = require(".");
const transcriptUtil_1 = require("./util/transcriptUtil");
const jmrBuilder = (jmr) => {
    let { actionItems, agendaItems, transcriptItems } = jmr;
    agendaItems = sortAgendaItems(agendaItems);
    transcriptItems = sortTranscriptItems(transcriptItems);
    return [
        {
            type: slateTypes_1.PseudoElementType.JmrOptions,
            children: [{ text: '' }],
        },
        {
            type: slateTypes_1.CustomElementType.JmrTitle,
            children: [
                (0, exports.createField)('', jmr.title, false, false, {
                    type: slateTypes_1.ObjectType.Jmr,
                    field: slateTypes_1.ObjectField.Title,
                    id: jmr.id,
                }),
            ],
        },
        (0, metaUtil_1.getJmrMetaData)(jmr),
        (0, exports.createJmrHeader)('Purpose'),
        (0, exports.createField)('This meeting needs a purpose...', jmr.purpose, true, false, {
            type: slateTypes_1.ObjectType.Jmr,
            field: slateTypes_1.ObjectField.Purpose,
            id: jmr.id,
        }),
        (0, exports.createJmrHeader)('Notes'),
        (0, exports.createField)('Add some notes to this JMR...', jmr.notes, true, false, {
            type: slateTypes_1.ObjectType.Jmr,
            field: slateTypes_1.ObjectField.Notes,
            id: jmr.id,
        }),
        {
            type: slateTypes_1.CustomElementType.ActionList,
            children: [
                {
                    type: slateTypes_1.CustomElementType.Hidden,
                    children: [{ text: '' }],
                },
                ...actionItems.map((item) => (0, actionUtil_1.createActionItemElement)(slateTypes_1.ItemStatus.Existed, { item })),
            ],
        },
        {
            type: slateTypes_1.CustomElementType.Agenda,
            children: agendaItems.length === 0
                ? [
                    (0, agendaUtil_1.createAgendaItemElement)({
                        status: slateTypes_1.ItemStatus.Created,
                        defaultAssignee: jmr.owner,
                    }),
                ]
                : agendaItems.map((item) => (0, agendaUtil_1.createAgendaItemElement)({ status: slateTypes_1.ItemStatus.Existed, seqNum: item.seqNum }, item)),
        },
        {
            type: slateTypes_1.CustomElementType.Transcript,
            children: transcriptItems.length === 0
                ? [(0, _1.createUtteranceElement)((0, transcriptUtil_1.createEmptyPartial)(), slateTypes_1.ItemStatus.Created)]
                : [
                    (0, _1.createUtteranceElement)((0, transcriptUtil_1.createEmptyPartial)(), slateTypes_1.ItemStatus.Created),
                    ...transcriptItems.map((item) => (0, _1.createUtteranceElement)(item, slateTypes_1.ItemStatus.Existed)),
                ],
        },
    ];
};
exports.jmrBuilder = jmrBuilder;
const sortAgendaItems = (items) => {
    return items.sort((a, b) => {
        return parseInt(a.seqNum) - parseInt(b.seqNum);
    });
};
const sortTranscriptItems = (items) => {
    return items.sort((a, b) => {
        const aDate = new Date(a.startDate);
        const bDate = new Date(b.startDate);
        return aDate > bDate ? -1 : 1;
    });
};
const createJmrHeader = (header) => {
    return {
        type: slateTypes_1.CustomElementType.JmrHeader,
        header,
        children: [{ text: '' }],
    };
};
exports.createJmrHeader = createJmrHeader;
const createField = (placeholder, data, isRich, isNew, artifactId) => {
    return {
        type: isRich ? slateTypes_1.CustomElementType.RichText : slateTypes_1.CustomElementType.SimpleText,
        artifactId,
        placeholder,
        children: isRich ? (isNew ? [(0, exports.createBlock)('')] : JSON.parse(data)) : [(0, exports.createBlock)(data)],
    };
};
exports.createField = createField;
const createBlock = (data) => {
    return {
        type: slateTypes_1.CustomElementType.TextBlock,
        children: [{ text: data }],
    };
};
exports.createBlock = createBlock;
